import React, { useMemo } from 'react';
import { Icon, Tooltip } from '@b-design/fusion';
import { stepConfig, linkToDocument } from './stepConfig';
import $i18n from '../../../../i18n';
import store from '@/store';
// import arrow from '@/assets/overview/arrow.png';
import { history } from 'ice';
// import triangle from '@/assets/login/triangle.svg';
import langObj from '@/i18n';
import { getImages } from '@/utils/theme';

import './index.less';

const Banner: React.FC = () => {
  const [spaceRoleState] = store.useModel('spaceRole');
  const spaceId = spaceRoleState?.spaceId || '';

  const images = useMemo(() => {
    return getImages();
  }, [window.__SUPERAPP_CONFIG__?.themeColors]);

  const renderContent = (key) => {
    if (key === '01') {
      return $i18n.get({
        id: 'aopf.pages.overview.Contact.Developer.admin.to.create.app',
        dm: '联系开发人员管理员创建应用程序',
      });
    } else if (key === '02') {
      return $i18n.get({
        id: 'aopf.pages.overview.Contact.Developer.admin.to.add.member',
        dm: '联系开发人员管理员添加成员',
      });
    }
    return;
  };

  const renderItem = (item) => {
    if (item.key === '01' || item.key === '02') {
      return spaceRoleState?.roleList?.includes('ADMIN') ? (
        <div
          onClick={() => {
            if (item.key === '01') {
              history?.push(`/miniapp?spaceId=${spaceId}&showDrawer=${true}`);
            }
            if (item.key === '02') {
              history?.push(`/members?spaceId=${spaceId}&isTrue=${true}`);
            }
          }}
          className={`${item.key === '01' ? 'item-create' : 'item-add'}`}
        >
          <div className="item-title">{item.title}</div>
          <div className="item-arrow-right">
            <Icon type="arrow--right" size="xs" />
          </div>
        </div>
      ) : (
        <>
          <div className={`item-title ${item.key === '01' ? 'item-create-dev' : 'item-add-dev'}`}>
            {item.title}
            <Tooltip
              align="b"
              v2
              trigger={
                <Icon
                  type="information--filled"
                  size="xs"
                  style={{ display: 'inline-block', marginLeft: 2 }}
                />
              }
              closable={false}
              style={{ width: 176 }}
            >
              {renderContent(item.key)}
            </Tooltip>
          </div>
        </>
      );
    }
    if (item.key === '03') {
      return (
        <div
          className="ide-div-content"
          onClick={() => {
            langObj.language === 'en-US'
              ? window.open(linkToDocument.ide.en)
              : window.open(linkToDocument.ide.zh);
          }}
        >
          <div className="item-title">{item.title}</div>
          <div className="item-arrow-right">
            <Icon type="arrow--right" size="xs" />
          </div>
        </div>
      );
    }
    if (item.key === '04' || item.key === '06' || item.key === '07') {
      return (
        <>
          {item.key === '06' ? (
            <div
              className={`item-title ${
                item.key !== '06' ? 'link-div-contaner' : 'link-div-content'
              }`}
            >
              <a
                className="item-title-link link-submit-approval"
                onClick={() => {
                  langObj.language === 'en-US'
                    ? window.open(linkToDocument.approval.en)
                    : window.open(linkToDocument.approval.zh);
                }}
              >
                {item.title}
              </a>
              <Icon
                type="launch"
                size="xs"
                style={{ position: 'relative', left: 8 }}
                onClick={() => {
                  langObj.language === 'en-US'
                    ? window.open(linkToDocument.approval.en)
                    : window.open(linkToDocument.approval.zh);
                }}
              />
            </div>
          ) : (
            <div className="item-title">
              <a
                className="item-title-link link-to-div"
                onClick={() => {
                  if (item.key === '04') {
                    langObj.language === 'en-US'
                      ? window.open(linkToDocument.debugging.en)
                      : window.open(linkToDocument.debugging.zh);
                  }
                  if (item.key === '07') {
                    langObj.language === 'en-US'
                      ? window.open(linkToDocument.release.en)
                      : window.open(linkToDocument.release.zh);
                  }
                }}
              >
                {item.title} <Icon type="launch" size="xs" />
              </a>
            </div>
          )}
        </>
      );
    }

    if (item.key === '05') {
      return (
        <div className="build-version-container">
          <div className="item-title item-title-version">{item.title}</div>
          <a
            className="item-sub-link"
            onClick={() => {
              langObj.language === 'en-US'
                ? window.open(linkToDocument.build.en)
                : window.open(linkToDocument.build.zh);
            }}
          >
            {$i18n.get({ id: 'aopf.pages.overview.IDE', dm: 'IDE上传' })}{' '}
            <Icon type="launch" size="xs" />
          </a>
          <br />
          <a
            className="item-sub-link"
            onClick={() => {
              langObj.language === 'en-US'
                ? window.open(linkToDocument.build.en)
                : window.open(linkToDocument.build.zh);
            }}
          >
            {$i18n.get({ id: 'aopf.pages.overview.File', dm: '文件上传' })}{' '}
            <Icon type="launch" size="xs" />
          </a>
        </div>
      );
    }

    return;
  };

  const renderTitles = (item) => {
    return (
      <div className="banner-name-link-container">
        <div className={`${item.key === '01' ? 'banner-name-link-item-container' : ''}`} />
        {renderItem(item)}
      </div>
    );
  };

  return (
    <div className="overview-banner" style={{ backgroundImage: window.__SUPERAPP_CONFIG__?.homePage?.stepBg || "var(--superapp-bg-gradient)" }}>
      {/* <img src={triangle} alt="" className="img-banner" /> */}
      {stepConfig.map((item, index) => (
        <div className="banner-item" key={item.key}>
          <div className="img-content-div">
            <img
              src={"https://gw.alicdn.com/imgextra/i4/O1CN015Zrqfr1hrePkYEYLw_!!6000000004331-2-tps-60-60.png"}
              className={`img-arrow-bannner ${
                item.key === '01' ? 'img-arrow-none' : 'img-arrow-inline'
              }`}
              alt=""
            />
            <img
              // src={spaceRoleState?.roleList?.includes('ADMIN') ? item.imgUrlAdmin : item.imgUrlDeveloper}
              src={images['homeStep0' + (index + 1)]}
              style={
                ['01', '02'].includes(item.key) && !spaceRoleState?.roleList?.includes('ADMIN')
                  ? { opacity: '0.4' }
                  : undefined
              }
              alt=""
              className={`item-img ${item.key === '01' ? 'img-left-position' : ''}`}
            />
          </div>
          {renderTitles(item)}
        </div>
      ))}
    </div>
  );
};

export default Banner;
